import { i18n } from "../../../../../language";

const $menuT = (that, key) => {
    if (that && that.$t) {
        return that.$t(key);
    }
    return i18n.t(key);
};

const MENU_TYPES = {
    BALANCE: "balance",
    CDR: "cdr",
    USER_MAPPING: "user-mapping",
    SETTINGS: "settings",
    AUTOMATIONS: "automations",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.BALANCE,
        label: $menuT(that, "menu.balance"),
        icon: {
            type: "material-icons",
            name: "account_balance_wallet",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.CDR,
        label: $menuT(that, "menu.callRecords"),
        icon: {
            type: "material-icons",
            name: "record_voice_over",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.USER_MAPPING,
        label: $menuT(that, "menu.userMapping"),
        icon: {
            type: "material-icons",
            name: "person",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.SETTINGS,
        label: $menuT(that, "menu.settings"),
        icon: {
            type: "material-icons",
            name: "settings",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.AUTOMATIONS,
        label: $menuT(that, "menu.automations"),
        icon: {
            type: "component",
            name: "AutomationIcon",
            class: "myIcon",
            style: { fill: "var(--color-icon-primary-default)" },
        },
        group: $menuT(that, "menu.mainSettings"),
    },
];

export default {
    MENU_TYPES,
    Items,
};
